<ng-container *ngFor="let part of highlightedOption; let isOdd = odd">
  <span
    *ngIf="isOdd; else even"
    class="highlighted-text"
    [dgxQmSanitise]="sanitise"
    >{{ part }}</span
  >
  <ng-template #even>{{ part }}</ng-template>
</ng-container>
